export const nzResidentialStatusOptions = [
  { label: "I own my home outright", value: "OUTRIGHT" },
  { label: "I have a mortgage", value: "MORTGAGE" },
  { label: "I'm boarding", value: "BOARDING" },
  { label: "I'm renting", value: "RENTING" },
  { label: "I live with my parents", value: "LIVE_IN" },
] as const;
